import { OosReplacementRow } from './oos-replacement-row';

export { OosReplacementRow };
